import {Component, inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {IntegrationsService} from '../integrations/integrations.service';
import {AuthType, SlackIntegrationPayload} from '../../../shared/models/integration-requests';
import {environment} from '../../../environments/environment.dev';


@Component({
  selector: 'app-slack-oauth',
  standalone: true,
  imports: [],
  template: `<p>Redirecting...</p>`,
})
export class SlackOauthComponent implements OnInit{
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private integrationService: IntegrationsService = inject(IntegrationsService);
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const code = params['code'] as string | undefined;
      const error = params['error'];
      const errorDescription = params['error_description'];

      if (error === 'access_denied') {
        console.warn("Slack OAuth was cancelled by user.");
        this.router.navigate(["settings/integrations"], {
          queryParams: {
            args: 'SLACK',
            error: 'cancelled',
            message: errorDescription || 'User denied access.'
          }
        });
        return;
      }

      if (!code) {
        console.error("Slack OAuth failed or no code received.");
        this.router.navigate(["settings/integrations"], {
          queryParams: {
            args: 'SLACK',
            error: 'cancelled'
          }
        });
        return;
      }


      const payload: SlackIntegrationPayload = {
        redirectUri: environment.slack.redirectUri,
        code: code,
        authType: AuthType.SLACK
      };

      this.integrationService.createSlackIntegration(payload).subscribe({
        next: () => { },
        error: (err: any) => {
          console.error(err);
          this.router.navigate(["settings/integrations"], {
            queryParams: {
              args: 'SLACK',
              error: 'failed'
            }
          });
        },
        complete: () => {
          console.log('Code sent to backend');
          this.router.navigate(["settings/integrations"], {
            queryParams: {
              args: 'SLACK'
            }
          });
        }
      });
    });
  }
}
